import { z } from 'zod';
/**
 * Mögliche Ergebnisse einer Einreichung in der Reihenfolge ihrer Wertigkeit.
 * Die Reihenfolge entspricht der Deklaration des Datenbank-Enums `outcome`
 * (siehe db/migrations) – Vergleiche wie „mindestens Annahme" stützen sich darauf.
 */
export const OUTCOMES = ['open', 'rejected', 'acceptance', 'honorable_mention', 'medal'];
/** Zod-Schema zur Validierung eines Ergebniswerts in API-Eingaben. */
export const outcomeSchema = z.enum(OUTCOMES);
/**
 * Liefert die Rangstufe eines Ergebnisses (open = 0 … medal = 4).
 * @param outcome Das zu bewertende Ergebnis.
 * @returns Position in der Wertigkeitsreihenfolge.
 */
export function outcomeRank(outcome) {
    return OUTCOMES.indexOf(outcome);
}
/**
 * Prüft, ob ein Ergebnis mindestens so wertig ist wie ein Schwellenwert.
 * Beispiel: `isAtLeast('medal', 'acceptance')` ist wahr, `isAtLeast('rejected', 'acceptance')` falsch.
 * @param outcome Das geprüfte Ergebnis.
 * @param threshold Die Mindestwertigkeit.
 * @returns `true`, wenn `outcome` nicht unter `threshold` liegt.
 */
export function isAtLeast(outcome, threshold) {
    return outcomeRank(outcome) >= outcomeRank(threshold);
}
/**
 * Prüft, ob ein Ergebnis als Erfolg zählt (Annahme oder besser).
 * @param outcome Das geprüfte Ergebnis.
 * @returns `true` bei Annahme, Urkunde/HM oder Medaille.
 */
export function isSuccess(outcome) {
    return isAtLeast(outcome, 'acceptance');
}
//# sourceMappingURL=outcome.js.map